import { type DefaultTheme } from 'styled-components';

import { emToPx, pxToEm } from '../helpers/css-units';

export const breakpointsType = {
  xs: 'xs', // mobile
  s: 's', // tablet
  m: 'm', // laptop
  l: 'l', // desktop
};

export const breakpoints = {
  s: pxToEm('600px'),
  m: pxToEm('1024px'),
  l: pxToEm('1440px'),
} as const;
export type Breakpoints = typeof breakpoints;

export const devices = {
  mobile: { max: breakpoints.s },
  tablet: { min: pxToEm(emToPx(breakpoints.s) + 1), max: breakpoints.m },
  laptop: { min: pxToEm(emToPx(breakpoints.m) + 1), max: breakpoints.l },
  desktop: { min: pxToEm(emToPx(breakpoints.l) + 1) },
} as const;
export type Devices = typeof devices;
export type Device = keyof Devices;

export const makeMediaQuery = (widths: { min?: string; max?: string }): string => {
  const query = [widths.min && `(min-width: ${widths.min})`, widths.max && `(max-width: ${widths.max})`]
    .filter(Boolean)
    .join(' and ');
  return `@media ${query}`;
};

export type DeviceMediaQueries = Record<Device, string>;
export const makeMediaQueries = (mediaDevices: Devices): Record<Device, string> => {
  const entries = Object.entries(mediaDevices).map(([name, widths]) => [name, makeMediaQuery(widths)]);
  return Object.fromEntries(entries);
};

export const mediaQueryFor =
  (device: Device) =>
  ({ theme }: { theme: DefaultTheme }): string =>
    theme.deviceMediaQueries[device];
